(function () {
  class FrogView extends PIXI.Container {
    constructor() {
      super();
      this._frogAnimContainer = null;
      this._frogAnim = null;

      const self = this;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      const baseName = "frogContainer:FrogView";

      this._frogAnimContainer = resourceManager.get(
        `${baseName}:frogAnimContainer`
      );

      this._frogAnim = resourceManager.createObject(
        "spine",
        "frogSpine",
        this._frogAnimContainer.name,
        {
          name: "FrogAnim",
          defaultAnimation: "Idle_01",
          scale: 0.4,
        }
      );
      this._frogAnim.stop();
      this._frogAnim.visible = false;
      this._frogAnim.alpha = 0;

      const DEFAULT_MIX_TIME = 0.2;
      this._frogAnim.mixAnims("Idle_01", "Reel Spin", DEFAULT_MIX_TIME);
      this._frogAnim.mixAnims("Idle_01", "Symbol_Win", DEFAULT_MIX_TIME);

      this._frogAnim.mixAnims("Idle_02", "Reel Spin", DEFAULT_MIX_TIME);
      this._frogAnim.mixAnims("Idle_02", "Symbol_Win", DEFAULT_MIX_TIME);

      this._frogAnim.mixAnims("Reel Spin", "Symbol_Win", DEFAULT_MIX_TIME);

      this._frogAnim.mixAnims("Symbol_Win", "Reel Spin", DEFAULT_MIX_TIME);
    }

    getFrogAnim() {
      return this._frogAnim;
    }

    isVisible() {
      return this._frogAnim.visible && this._frogAnim.alpha !== 0;
    }

    playFrogStartAnim() {
      if (GLOBALS.getRandom(3) === 1) {
        this._frogAnim.play("Idle_02", false, 0, () => {
          this.playFrogIdleIndefinitely();
        });
      } else if (!this._frogAnim.isPlaying()) {
        this.playFrogIdleIndefinitely();
      }
    }

    playFrogCascadeAnim() {
      this._frogAnim.play("Reel Spin", false, 0, () => {
        this.playFrogIdleIndefinitely();
      });
    }

    playFrogFSEndAnim() {
      this._frogAnim.play("Symbol_Win", false, 0, () => {
        this.playFrogIdleIndefinitely();
      });
    }

    playFrogIdleIndefinitely() {
      this._frogAnim.play("Idle_01", true);
    }
  }

  create = function (json) {
    return new FrogView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "FrogView",
    create,
    initialise,
    getFilesRequired
  );
})();
